// extracted by mini-css-extract-plugin
export default {"mainIntro":"MainIntro_mainIntro__5L9Ik","mainIntroSmaller":"MainIntro_mainIntroSmaller__ve0Pc","title":"MainIntro_title__iyAV3","moreBtn":"MainIntro_moreBtn__5o67e"};